module.exports = "/images/expired_access.png?1bafda1471a61f85431e44be0b01fe6f";